import { IcnSearch, Kbd, PrimitiveButton } from '@viquard/doc-ui';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface SearchTriggerProps {
  onOpen?: () => void;
}

/** Pill-shaped site-search trigger. Replicates the DEMO topbar's ⌘K
 *  affordance while delegating the actual dialog to the app shell. */
export function SearchTrigger({ onOpen }: SearchTriggerProps): ReactNode {
  const { t } = useTranslation('common');
  return (
    <PrimitiveButton
      onClick={onOpen}
      aria-label={t('search.label')}
      className="topbar-search-trigger inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-sm transition-colors"
      style={{
        background: 'var(--vq-paper-sunk)',
        border: '1px solid var(--vq-rule)',
        color: 'var(--vq-ink-3)',
        cursor: 'pointer',
      }}
    >
      <IcnSearch size={14} />
      <span className="topbar-search-trigger__label flex-1 text-left">
        {t('search.placeholder')}
      </span>
      <span className="topbar-search-trigger__kbd inline-flex">
        <Kbd>⌘K</Kbd>
      </span>
    </PrimitiveButton>
  );
}
